import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, FileText } from 'lucide-react';
import { Button } from '../ui/Button';
import { Logo } from './Logo';
import { useDrawers } from '../../contexts/DrawerContext';
import { cn } from '../../lib/utils';
const NAV_LINKS = [{
  label: 'Buying',
  href: '/buying-property'
}, {
  label: 'Selling',
  href: '/selling-property'
}, {
  label: 'Contract Review',
  href: '/contract-review'
}, {
  label: 'SMSF & Trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial Property',
  href: '/commercial-property'
}, {
  label: 'Resources',
  href: '/resources'
}, {
  label: 'About',
  href: '/about'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    openQuote,
    openUpload
  } = useDrawers();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);
  return <header className={cn('sticky top-0 left-0 right-0 z-40 transition-all duration-300 ease-soft border-b', isScrolled ? 'bg-background/90 backdrop-blur-xl border-border py-2.5 shadow-subtle' : 'bg-background border-border/70 py-3.5')} data-id="element-466">
      <div className="max-w-7xl mx-auto px-5 md:px-6 flex items-center justify-between" data-id="element-467">
        <Logo data-id="element-468" />

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary" data-id="element-469">
          <ul className="flex items-center gap-6" data-id="element-470">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-471">
                <Link to={link.href} className="text-[15px] font-medium text-ink/80 hover:text-accent transition-colors" data-id="element-472">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="flex items-center gap-3 border-l border-border pl-6" data-id="element-473">
            <a href="tel:+61386172600" className="flex items-center gap-2 text-sm font-semibold text-ink hover:text-accent transition-colors" data-id="element-474">
              <Phone className="w-4 h-4" data-id="element-475" />
              (03) 8617 2600
            </a>
            <Button onClick={openQuote} variant="accent" size="sm" data-id="element-476">
              Get a free quote
            </Button>
          </div>
        </nav>

        <div className="flex items-center gap-1.5 lg:hidden" data-id="element-477">
          <a href="tel:+61386172600" className="text-ink hover:text-accent p-2.5 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Call L.A Property Law" data-id="element-478">
            <Phone className="w-5 h-5" data-id="element-479" />
          </a>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-ink p-2.5 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen} data-id="element-480">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-481" /> : <Menu className="w-6 h-6" data-id="element-482" />}
          </button>
        </div>
      </div>

      <div className={cn('fixed inset-0 bg-background z-30 lg:hidden transition-transform duration-300 ease-soft pt-24 px-6 pb-40 overflow-y-auto', isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full')} data-id="element-483">
        <nav className="flex flex-col gap-6" aria-label="Mobile" data-id="element-484">
          <ul className="flex flex-col" data-id="element-485">
            {NAV_LINKS.map(link => <li key={link.label} className="border-b border-border" data-id="element-486">
                <Link to={link.href} className="text-2xl font-serif text-ink block py-4 hover:text-accent transition-colors" data-id="element-487">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="mt-6 space-y-5" data-id="element-488">
            <div className="space-y-1.5" data-id="element-489">
              <p className="text-xs text-muted-ink uppercase tracking-[0.2em]" data-id="element-490">
                Speak with the team
              </p>
              <a href="tel:+61386172600" className="text-2xl font-serif text-ink block" data-id="element-491">
                (03) 8617 2600
              </a>
              <a href="mailto:hello@lapropertylaw.com.au" className="text-base text-brand-blue block" data-id="element-492">
                hello@lapropertylaw.com.au
              </a>
            </div>

            <div className="grid grid-cols-1 gap-3 pt-2" data-id="element-493">
              <Button onClick={() => {
              openUpload();
              setIsMobileMenuOpen(false);
            }} variant="accent" fullWidth size="lg" data-id="element-494">
                <FileText className="w-5 h-5" data-id="element-495" />
                Upload a contract
              </Button>
              <Button onClick={() => {
              openQuote();
              setIsMobileMenuOpen(false);
            }} variant="outline" fullWidth size="lg" data-id="element-496">
                Get a free quote
              </Button>
            </div>
          </div>
        </nav>
      </div>
    </header>;
}